import { render, staticRenderFns } from "./function-compare.vue?vue&type=template&id=72cffd46&scoped=true"
import script from "./function-compare.vue?vue&type=script&lang=js"
export * from "./function-compare.vue?vue&type=script&lang=js"
import style0 from "./function-compare.vue?vue&type=style&index=0&id=72cffd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cffd46",
  null
  
)

export default component.exports